type MapTractorIconProps = {
  className?: string;
};

export const MapTractorIcon = ({
  className,
}: MapTractorIconProps): React.ReactElement => (
  <svg
    className={className}
    id="Group_3260"
    data-name="Group 3260"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19.789 19.789"
  >
    <circle
      id="Ellipse_93"
      data-name="Ellipse 93"
      cx="9.895"
      cy="9.895"
      r="9.895"
      transform="translate(0 0)"
      fill="#1a89e9"
    />
    <path
      id="Path_349"
      data-name="Path 349"
      d="M4.484,100.07a1.052,1.052,0,1,1-1.052-1.076A1.064,1.064,0,0,1,4.484,100.07Zm-.526,0a.526.526,0,1,0-.526.538.532.532,0,0,0,.526-.538ZM2.526,98.994H.169A.174.174,0,0,0,0,99.168v.525a.174.174,0,0,0,.169.174h1.89A1.428,1.428,0,0,1,2.526,99Zm7.462,1.076a1.052,1.052,0,1,1-1.052-1.076A1.064,1.064,0,0,1,9.988,100.07Zm-.526,0a.526.526,0,1,0-.526.538A.532.532,0,0,0,9.462,100.07Zm2.385-.9v.525a.174.174,0,0,1-.169.174h-1.37a1.384,1.384,0,0,0-2.748,0H4.807A1.428,1.428,0,0,0,4.339,99H6.95v-4.95a.342.342,0,0,1,.338-.347h1.6A1.345,1.345,0,0,1,10,94.309l1.029,1.558a1.406,1.406,0,0,1,.232.774v2.349h.411a.174.174,0,0,1,.174.177Zm-1.713-3.256-.823-1.2a.168.168,0,0,0-.138-.074H7.888a.174.174,0,0,0-.169.174v1.2a.174.174,0,0,0,.169.174H9.995a.174.174,0,0,0,.14-.274Z"
      transform="translate(4.508 -87.056)"
      fill="#fff"
    />
    <path
      id="Union_17"
      data-name="Union 17"
      d="M.347,5.212A.347.347,0,0,1,0,4.865V.347A.347.347,0,0,1,.347,0H6.023A.347.347,0,0,1,6.37.347V4.865a.347.347,0,0,1-.347.347ZM.579.927V4.286a.347.347,0,0,0,.108.252L5.708.7A.347.347,0,0,0,5.444.579H.927A.347.347,0,0,0,.579.927Z"
      transform="translate(4.508 6.257)"
      fill="#fff"
    />
  </svg>
);
